// extracted by mini-css-extract-plugin
module.exports = {"modal":"ImageModal_modal__30Gjg","container":"ImageModal_container__3ROwt","image":"ImageModal_image__1zZ2A","closeBtn":"ImageModal_closeBtn__2_pgG"};